import { render, staticRenderFns } from "./FotoRow.vue?vue&type=template&id=bc4330c8&scoped=true&lang=pug&"
import script from "./FotoRow.vue?vue&type=script&lang=js&"
export * from "./FotoRow.vue?vue&type=script&lang=js&"
import style0 from "./FotoRow.vue?vue&type=style&index=0&id=bc4330c8&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc4330c8",
  null
  
)

export default component.exports